
<template>
	<div class="container1">
		<div class="search-box">
			<div class="search-left-box">
				<div class="input-box">
					<span>商品编号：</span>
					<el-input
						v-model="productCode"
						placeholder="请输入商品编号"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>商品名称：</span>
					<el-input
						v-model="productName"
						placeholder="请输入商品名称"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>店铺名称：</span>
					<el-select
						size="mini"
						class="name-input"
						popper-class="select"
						v-model="shopIds"
						filterable
						multiple
						collapse-tags
						placeholder="请选择店铺名称">
						<template v-for="item in shopList">
							<el-option
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</template>
					</el-select>
				</div>
				<div class="input-box">
					<span>是否可见：</span>
					<el-select v-model="visibleFlag" class="select-box" size='mini'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="1" label="可见"></el-option>
						<el-option :value="0" label="不可见"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>三方编号：</span>
					<el-input
						v-model="matchCode"
						placeholder="请输入三方编号"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>私密状态：</span>
					<el-select v-model="hiddenflag" class="select-box" size='mini'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="0" label="公开"></el-option>
						<el-option :value="1" label="私密"></el-option>
					</el-select>
				</div>
			</div>
			<div class="search-right-box">
				<div class="input-box-btn">
					<el-button type='primary' size='mini' class="fx-btn" style="margin-left:0" @click="search">查询</el-button>
					<el-button plain size='mini' class="fx-btn" @click="clear">清空</el-button>
				</div>
			</div>
		</div>
		<div class='table-box'>
			<el-table
				size='mini'
				class="grid-content"
				:data="tableData"
				:height="tableHeight"
				ref="table"
				border>
				<el-table-column
					label="商品名称"
					prop='productname'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="SPU编号"
					prop='productcode'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="三方编号"
					prop='matchcode'
					min-width="180"
					align="center">
				</el-table-column>
                <el-table-column
					label="规格名称"
					prop='spec'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="SKU编号"
					prop='speccode'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="销售价格"
					prop='price'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<span>{{scope.row.price === -1 ? '' : scope.row.price}}</span>
					</template>
				</el-table-column>
				<el-table-column
					label="修改时间"
					prop='modifydate'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="私密状态"
					prop='hiddenflag'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<span>{{scope.row.hiddenflag ? '私密' : '公开'}}</span>
					</template>
				</el-table-column>
				<el-table-column
					label="可见状态"
					prop='visibleflag'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<span>{{scope.row.visibleflag ? '可见' : '不可见'}}</span>
					</template>
				</el-table-column>
				<el-table-column
					label="店铺名称"
					prop='shopname'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<el-button size="mini" type='text'>{{scope.row.shopname}}</el-button>
					</template>
				</el-table-column>
				<el-table-column
					label="操作人"
					prop='createusername'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button v-if="AuthorityList['02_0005_0002_00']" size="mini" type='text' @click="show(scope.row)">设置价格</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog class="detail-dialog-title" title="商品价格设置" top='60px' :before-close='closeEdit' :visible.sync="editModal" width='520px' :close-on-click-modal="false">
				<Edit v-if="editModal" :editModal='editModal' :rpasid='rpasid' @cancel='closeEdit'/>
			</el-dialog>
		</div>
		<div style="margin-top:5px">
			<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="page.num"
			:page-sizes="[20,40, 60, 100, 300]"
			:page-size="page.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
			</el-pagination>
		</div>
	</div>
</template>
<script>
import Edit from '@/components/gradePrice/Edit.vue'
export default {
	name: 'table-box',
	components: {
		Edit
	},
	props: {
	},
	data () {
		return {
			rpasid: '',
			productCode: '',
			productName: '',
			bigTypeCategory: '',
			smallTypeCategory: '',
			visibleFlag: -1,
			hiddenflag: -1,
			matchCode: '',
			shopIds: [],
			editModal: false,
			editData: null,
			tableHeight: '100%',
			page: {
				size: 20,
				num: 1
			},
			total: null,
			shopList: [],
			tableData: [],
			keyword: '',
			AuthorityList: {
				'02_0005_0001_00': false,
				'02_0005_0002_00': false
			}
		}
	},
	created () {
		this.getAuthority('02_0005_0000_00')
		this.getShopList()
	},
	computed: {
	},
	methods: {
		closeEdit () {
			this.editModal = false
			this.tableReload()
		},
		show (data) {
			this.rpasid = data.rpasid
			this.editModal = true
		},
		changeData (data) {
			this.keyword = data.keyword
			this.bigTypeCategory = data.bigTypeCategory
			this.smallTypeCategory = data.smallTypeCategory
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		search () {
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		clear () {
			this.productCode = ''
			this.productName = ''
			this.shopIds = []
			this.visibleFlag = -1
			this.matchCode = ''
			this.hiddenflag = -1
			this.search()
		},
		tableReload () {
			let params = {
				shopIds: this.shopIds,
				productName: this.productName,
				productCode: this.productCode,
				matchCode: this.matchCode,
				bigTypeCategory: this.bigTypeCategory,
				smallTypeCategory: this.smallTypeCategory,
				keyword: this.keyword,
				visibleFlag: this.visibleFlag,
				hiddenflag: this.hiddenflag,
				page: this.page.num,
				size: this.page.size
			}
			this.params = params
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/getProductList4LevelPrice`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				this.total = +res.recordCount
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handlePageChange (val) {
			this.page.num = val
			this.tableReload()
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.container1{
	width:100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	.errormsgText{
		width:100%;
		text-align :left
		line-height:30px;
	}
	.batch-register-btn{
		color: var(--fx-primary-color);
		background: #ecf5ff;
		border-color: #b3d8ff;
		border-radius: 4px;
		cursor :pointer;
		font-size: 12px;
		margin-left: 10px;
		display: flex;
		width: 100px;
		justify-content center;
		align-items center;
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
	.search-box{
		padding-bottom :10px;
		width:100%;
		display:flex;
		// flex-wrap:wrap;
		border-bottom 1px solid #dce2fd
		.search-left-box {
			display:flex;
			flex-wrap:wrap;
			overflow: hidden
		}
		.search-right-box {
			// width: 200px;
			flex-shrink: 0;
			line-height: 30px
		}
		.input-box-btn{
			// width :80px;
		}
        .select-input{
                width :120px
            }
            .time-input{
                margin-left 10px
                width :320px
            }
        .time-box{
			text-align :left
            width :460px;
			margin-bottom:10px
			margin-right:10px

        }
		.input-box{
			overflow: hidden;
			text-align :left
			margin-right: 10px;
			margin-bottom:10px
			.name-input {
				width: 180px;
				margin-right: 10px;
			}
			.select-box{
				width:180px;
				margin-right:10px;
			}
		}
	}
	.name-box{
		padding-bottom :10px;
		margin-top :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		border-bottom 1px solid #dce2fd
		.input-box{
			text-align :left
			overflow-x :hidden
			margin-bottom:10px
		}
	}
	.btn-price-box{
		margin-top:10px;
		display :flex
	}
	.table-box{
		margin-top:8px;
		min-height:200px;
		flex: 1;
	}
}

</style>
<style lang="stylus">
	.el-select__tags{
		height: 28px;
	}
	.cell{
		padding: 0 !important
	}
.el-dialog__header{
    text-align left
}
.el-dialog__body {
	padding: 0px 20px 10px 20px;
}
.select {
	min-width: 280px !important
}
</style>
